<template>
    <div class="battery">
        <div class="top"></div>
        <div class="outer">
            <div
                v-for="n in 5"
                class="inner"
                :key="n"
                :class="{ hidden: n <= 5 - charge }"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Battery",

    data() {
        return {
            products: {},
        }
    },
}

</script>

<style scoped>
.battery {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.top {
    background: #000;
    width: 20px;
    height: 10px;
    border-radius: 10px 10px 0 0;
    margin-bottom: 2px;
}

.outer {
    width: 40px;
    border: 5px solid #000;
    height: 80px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

.inner {
    background: #009e13;
    flex: 1;
    margin: 2px;
    border-radius: 5px;
}

.inner.hidden {
    visibility: hidden;
}
</style>
